import type { BtlApplication } from '@api/btlApplicationForm/types';
import type { OoCaseSidebarContext } from '@components/CaseSidebar/buildOoCaseSidebar';
import { useSearchParams } from 'react-router-dom';
import { CaseApplicantIndividualPage } from './CaseApplicantIndividualPage';
import { CaseApplicantsList, OO_CREATE_INDIVIDUAL_SEARCH_PARAM } from './CaseApplicantsList';

interface CaseApplicantsPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
  sidebarContext: OoCaseSidebarContext;
}

export function CaseApplicantsPage({ case: caseData, isCaseLoading, sidebarContext }: CaseApplicantsPageProps) {
  const [searchParams] = useSearchParams();
  const individualId = searchParams.get('individualId');
  const isCreateMode = searchParams.get(OO_CREATE_INDIVIDUAL_SEARCH_PARAM) === '1';

  if (individualId || isCreateMode) {
    return (
      <CaseApplicantIndividualPage
        case={caseData}
        isCaseLoading={isCaseLoading}
        individualId={individualId}
        isCreateMode={isCreateMode}
        sidebarContext={sidebarContext}
      />
    );
  }

  return <CaseApplicantsList case={caseData} isCaseLoading={isCaseLoading} sidebarContext={sidebarContext} />;
}
